import React from "react";
import { cn } from "@/lib/utils";
import type { WaMessageStatus } from "@/types/whatsapp";

/** Default WhatsApp-style profile picture (grey circle with a person) */
export function WaAvatar({ size = 49, className }: { size?: number; className?: string }) {
  return (
    <div
      className={cn("shrink-0 rounded-full overflow-hidden flex items-end justify-center", className)}
      style={{ width: size, height: size, background: "var(--wa-avatar-bg)" }}
      aria-hidden
    >
      <svg viewBox="0 0 212 212" width={size} height={size}>
        <path
          fill="#fff"
          d="M106.251 35.65c-23.33 0-42.24 18.91-42.24 42.24s18.91 42.24 42.24 42.24 42.24-18.91 42.24-42.24-18.91-42.24-42.24-42.24zM173.42 212c-6.08-35.43-34.27-62.25-67.5-62.25S44.5 176.57 38.42 212h135z"
          opacity=".9"
        />
      </svg>
    </div>
  );
}

/** Sent ✓ / delivered ✓✓ / read (blue) ✓✓ / pending clock / failed */
export function WaTicks({ status, className }: { status: WaMessageStatus; className?: string }) {
  if (status === "QUEUED" || status === "RETRYING") {
    return (
      <svg viewBox="0 0 16 15" width="14" height="13" className={className} aria-label="Sending" fill="none" stroke="currentColor" strokeWidth="1.3" style={{ color: "var(--wa-muted)" }}>
        <circle cx="8" cy="7.5" r="5.6" />
        <path d="M8 4.4v3.3l2.2 1.4" strokeLinecap="round" />
      </svg>
    );
  }
  if (status === "FAILED") {
    return (
      <svg viewBox="0 0 16 16" width="14" height="14" className={className} aria-label="Failed">
        <circle cx="8" cy="8" r="7" fill="#ea0038" />
        <path d="M8 4.2v4.6M8 11.2v.1" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    );
  }
  const color = status === "READ" ? "var(--wa-tick)" : "var(--wa-muted)";
  const double = status === "DELIVERED" || status === "READ";
  return (
    <svg viewBox="0 0 18 11" width="17" height="11" className={className} aria-label={status === "READ" ? "Read" : double ? "Delivered" : "Sent"} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      {double ? (
        <>
          <path d="M1.5 5.8l3 3L11 2" />
          <path d="M7.4 8.6l.3.2L14.4 2" />
        </>
      ) : (
        <path d="M4 5.8l3 3L13.5 2" />
      )}
    </svg>
  );
}
